import React from 'react';
import styles from './UserRequest.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Carousel from 'component/molecules/carousel/Carousel';
import dummyProfile from '../../../../../assets/icons/vector/unknowUser.svg';
import TypingMessage from '../bot-response/factory/components/typying-message/TypingMessage';
import moment from 'moment';
import { chatDateFormat } from 'helpers/chatDateFormat';

const renderStepContent = ({ step, sideBar_PrimaryColor }) => {
  switch (step?.type) {
    case 'Message':
      return (
        <div className={styles['request-text-container']}>
          <div className={styles['request-text']}>
            <TypingMessage text={step.value} />
          </div>
          {step.isError ? (
            <span className={styles.error}>
              <p>!</p>
            </span>
          ) : null}
        </div>
      );

    case 'Image':
      return (
        <div className={styles['image-response']}>
          <img
            src={step.value}
            alt='Uploaded Image'
            className={styles['chat-image']}
          />
        </div>
      );

    case 'Video':
      return (
        <div className={styles['video-response']}>
          <video controls>
            <source src={step.value} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </div>
      );

    case 'Carousel':
      return (
        <div className={styles['carousel-response']}>
          {step?.value?.length > 0 ? (
            <Carousel data={step.value} />
          ) : (
            <p>No carousel items available</p>
          )}
        </div>
      );

    case 'Document':
      return (
        <div className={styles['file-response']}>
          <a href={step.value} target='_blank' rel='noopener noreferrer'>
            {step.value}
          </a>
          <SvgWithBranding
            type='file'
            className={styles.svg}
            color={sideBar_PrimaryColor}
          />
        </div>
      );

    case 'Audio':
      return (
        <div className={styles['voice-response']}>
          <audio controls>
            <source src={step.value} type='audio/webm' />
            Your browser does not support the audio element.
          </audio>
        </div>
      );

    default:
      return null;
  }
};

const UserRequest = ({ chatData, userData, sideBar_PrimaryColor }) => {
  return (
    <div className={styles['request-container']}>
      {/* <div className={styles['profile-image']}>
        {userData?.userImage?.userImage ? (
          <img
            src={`data:image/jpeg;base64,${userData?.userImage?.userImage}`}
            alt="User Profile"
            className={styles['expand-btn']}
          />
        ) : (
          <img
            src={dummyProfile}
            alt="User Profile"
            className={styles['expand-btn']}
          />
        )}
      </div> */}

      {chatData?.content && chatData?.content?.length > 0 ? (
        <div className={styles['request-wrapper']}>
          <div className={styles['request']}>
            <div className={styles['res-container']}>
              {chatData?.content?.map((step, index) => {
                const label = chatDateFormat(step?.dateCreated);

                return (
                  <div key={index}>
                    {renderStepContent({ step, sideBar_PrimaryColor })}
                    {label && (
                      <p className={styles['date']}>
                        <span dir='ltr'>{label}</span>
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default UserRequest;
